import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/xdp';

const ToggleButtonForTogglableContent = ({ collapsed }: { collapsed: boolean }) => (
  <Typography2 variant="subtitleMedium" component="span">
    {collapsed ? _t('Read more') : _t('Read less')}
  </Typography2>
);

export default ToggleButtonForTogglableContent;
